import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-edit-income',
  templateUrl: './edit-income.component.html',
  styleUrls: ['./edit-income.component.css']
})
export class EditIncomeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
